import styled from '@emotion/styled';

export const StyledErrorMessage = styled.div`
    color: ${({ theme }) => theme.color.bloodyMary};
    padding: ${({ theme }) => theme.spacing[1]} 0;
`;
